
import { defineComponent, onMounted, ref } from 'vue'
import ListContentLayout from '@/views/layout/ListContentLayout.vue'
import { repositories } from '@/repositories/system/repositories'
import { NoticeItem } from '@/repositories/system/noticeRepository'
import { callApiWrapper } from '@/views/callApiWrapper'
import ConfirmDeleteNotice from '@/views/system/ConfirmDeleteNotice.vue'

const repository = repositories.notice

export default defineComponent({
  components: {
    ConfirmDeleteNotice,
    ListContentLayout
  },
  setup () {
    const requestError = ref<string | null>(null)
    const deleteTargetNotice = ref<NoticeItem | null>(null)
    const notices = ref<NoticeItem[]>([])

    onMounted(async () => {
      await updateList()
    })

    const updateList = async () => {
      await callApiWrapper(requestError, async () => {
        notices.value = await repository.list()
      })
    }

    const onClickDelete = (target: NoticeItem) => {
      deleteTargetNotice.value = target
    }

    return {
      notices,
      deleteTargetNotice,
      onClickDelete,
      updateList
    }
  }
})
